/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Name_HeaderInputs */

const en_explorer_table_name_header = /** @type {(inputs: Explorer_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const fr_explorer_table_name_header = /** @type {(inputs: Explorer_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

const de_explorer_table_name_header = /** @type {(inputs: Explorer_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const it_explorer_table_name_header = /** @type {(inputs: Explorer_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const ru_explorer_table_name_header = /** @type {(inputs: Explorer_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя`)
};

const es_explorer_table_name_header = /** @type {(inputs: Explorer_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

const zh_cn2_explorer_table_name_header = /** @type {(inputs: Explorer_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓名`)
};

const ja_explorer_table_name_header = /** @type {(inputs: Explorer_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

const hi_explorer_table_name_header = /** @type {(inputs: Explorer_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नाम`)
};

const pt_pt2_explorer_table_name_header = /** @type {(inputs: Explorer_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Explorer_Table_Name_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_name_header = /** @type {((inputs?: Explorer_Table_Name_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Name_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_table_name_header(inputs)
	if (locale === "de") return de_explorer_table_name_header(inputs)
	if (locale === "it") return it_explorer_table_name_header(inputs)
	if (locale === "ru") return ru_explorer_table_name_header(inputs)
	if (locale === "es") return es_explorer_table_name_header(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_table_name_header(inputs)
	if (locale === "ja") return ja_explorer_table_name_header(inputs)
	if (locale === "hi") return hi_explorer_table_name_header(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_table_name_header(inputs)
	return en_explorer_table_name_header(inputs)
});